export default __webpack_public_path__ + "static/DSC_6484-7dd8df08efcc85d6fdb769ea9512be5d.jpg";